import styled from 'styled-components6';
import { ReviewResponse } from './SplitDetails/ReviewResponse';
import { ReviewOverview } from './SplitDetails/ReviewOverview';
import { useReview } from '../../fetchers';
import { When } from 'react-if';
import { AnalyticsTargetLayerAreaProvider } from 'rwl-ui';
import { TargetLayerArea } from 'rwl-shared/dist/models/analytics';

const ReviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--rwl-spacing-md);
`;

export const DetailsReview = (): JSX.Element => (
    <ReviewContainer>
        <ReviewOverview />
        <ReviewResponse />
    </ReviewContainer>
);

export const LgReviewDetails = (): JSX.Element => {
    const { review } = useReview();
    return (
        <When condition={!!review}>
            <AnalyticsTargetLayerAreaProvider
                targetLayerArea={TargetLayerArea.REVIEWS}
            >
                <hr
                    style={{
                        color: 'var(--rwl-palette-gray-500)',
                        width: '100%',
                        borderTop: 'none',
                        borderLeft: 'none',
                    }}
                />
                <DetailsReview />
            </AnalyticsTargetLayerAreaProvider>
        </When>
    );
};
